export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Stroke Rehabilitation',
      description: 'Regaining independence and improving mobility through specialized neurological rehabilitation programs.',
    },
    {
      icon: 'ri-run-line',
      title: 'Sports Injury Management',
      description: 'Advanced recovery and prevention strategies designed specifically for athletes at all levels.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Lymphatic Drainage Therapy',
      description: 'Specialized care for Lipedema and post-body contouring with gentle, effective techniques.',
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Pain Management',
      description: 'Targeted relief for Knee, Neck, Back, and Shoulder pain using evidence-based approaches.',
    },
    {
      icon: 'ri-surgical-mask-line',
      title: 'Postoperative Rehabilitation',
      description: 'Restoring strength and function after surgery with personalized recovery programs.',
    },
    {
      icon: 'ri-parent-line',
      title: 'Pediatric Support',
      description: 'Specialized care for Children\'s Developmental Impairments with compassionate expertise.',
    },
    {
      icon: 'ri-bone-line',
      title: 'Arthritis Management',
      description: 'Comprehensive treatment for chronic joint conditions to improve mobility and reduce pain.',
    },
    {
      icon: 'ri-pulse-line',
      title: 'Sciatica Treatment',
      description: 'Specialized treatment for chronic nerve conditions with targeted therapeutic interventions.',
    },
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-[#F0F9FF] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B4F6C] mb-4">
            Our Specialized Services
          </h2>
          <div className="w-20 h-1 bg-[#14B8A6] mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Comprehensive physiotherapy solutions tailored to your unique needs and recovery goals
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6] to-[#0D9488] rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#0B4F6C] mb-3 group-hover:text-[#14B8A6] transition-colors">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}